import {
  LABOTURNOS_SUCCESS,
  LABOTURNOS_LOADING,
  LABOTURNOS_ERROR,
  LABOTURNOS_LOGOUT,
  LABOTURNOS_FLG_CAMBIARTURNO,
  LABOTURNOS_FLG_BUSCARTURNOLABO,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import laboTurnosInitialState from "../initialStates/laboTurnosInitialState";

const laboTurnos = (state, { payload, type }) => {
  switch (type) {
    case LABOTURNOS_LOADING:
      return {
        ...state,
        laboTurnos: {
          ...state.laboTurnos,
          error: false,
          loading: true,
        },
      };
    case LABOTURNOS_SUCCESS:
      return {
        ...state,
        laboTurnos: {
          ...state.laboTurnos,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LABOTURNOS_FLG_CAMBIARTURNO:
      return {
        ...state,
        laboTurnos: {
          ...state.laboTurnos,
          flgCambiarTurno: payload,
        },
      };
    case LABOTURNOS_FLG_BUSCARTURNOLABO:
      return {
        ...state,
        laboTurnos: {
          ...state.laboTurnos,
          flgBuscarTurno: payload,
        },
      };
    case LABOTURNOS_ERROR:
      return {
        ...state,
        laboTurnos: {
          ...state.laboTurnos,
          error: payload,
          loading: false,
        },
      };
    case LABOTURNOS_LOGOUT:
      return laboTurnosInitialState;
    case RESET_PORTAL_CONTEXT:
      return laboTurnosInitialState;

    default:
      return state;
  }
};

export default laboTurnos;
